import {BrowserRouter, Route, Routes} from "react-router-dom";
import React, {Suspense} from "react";
import {Layout} from "../components/Layout";
import {LandingPage} from "../pages/landing";
import {ROUTER_PATHS} from "./paths";
import {RankingsPage} from "../pages/rankings";

export const AppRouter: React.FC = () => {
    return <BrowserRouter basename={process.env.PUBLIC_URL}>
        <Suspense fallback={<></>}>
            <Routes>
                <Route path={ROUTER_PATHS.RANKINGS} element={<Layout/>}>
                    <Route path={""} element={<RankingsPage/>}/>
                </Route>
                <Route path={"*"} element={<Layout/>}>
                    <Route path={""} element={<LandingPage/>}/>
                </Route>
            </Routes>
        </Suspense>
    </BrowserRouter>
}
